import React from "react";
import { node } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import InfoTag from "pages/echeck/components/InfoTag";
import FormattedDate from "pages/_components/FormattedDate";
import CustomData from "pages/_components/CustomData/CustomData";
import { statusTransmitTagColor } from "util/cedip";

const TransmissionsCedip = ({ data }) => (
    <GridTable.Container columns={3} columnsTemplate="fixed">
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="cedips.transmissions.transmitter"
                    titleTextType="I18N"
                    valueText={
                        <>
                            <p>{data?.razonSocialTransmisor}</p>
                            <p>CUIT: {data?.cuitTransmisor}</p>
                        </>
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="cedips.transmissions.beneficiary"
                    titleTextType="I18N"
                    valueText={
                        <>
                            <p>{data?.razonSocialBeneficiario}</p>
                            <p>CUIT: {data?.cuitBeneficiario}</p>
                        </>
                    }
                    valueTextType="TEXT"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <GridTable.Data>
                    <CustomData
                        titleText="cedips.transmissions.date"
                        titleTextType="I18N"
                        valueText={<FormattedDate date={data?.fecha} dateFormat="DD/MM/YYYY" />}
                        valueTextType="TEXT"
                    />
                </GridTable.Data>
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <CustomData
                    titleText="cedips.transmissions.type"
                    titleTextType="I18N"
                    valueText={`cedips.transmissions.type.${data?.tipo}`}
                    valueTextType="I18N"
                />
            </GridTable.Container>
        </GridTable.Data>
        <GridTable.Data>
            <GridTable.Container>
                <div className="pl-4">
                    <InfoTag
                        type="info"
                        message={data?.estado}
                        tagBackground={statusTransmitTagColor(data?.estado?.toUpperCase())}
                    />
                </div>
            </GridTable.Container>
        </GridTable.Data>
    </GridTable.Container>
);

TransmissionsCedip.propTypes = {
    data: node.isRequired,
};

export default TransmissionsCedip;
